import { parse, stringify } from 'query-string';
const SEARCH_STRING_REGEX = /([^?]+)?(\?.*)?/;
const extractRegex = (regex, group, string) => {
    const result = regex.exec(string);
    return result !== null && result.length > group ? result[group] : null;
};
const extractPathname = (uri) => {
    return extractRegex(SEARCH_STRING_REGEX, 1, uri);
};
const extractSearch = (uri) => {
    const search = extractRegex(SEARCH_STRING_REGEX, 2, uri);
    if (!search) {
        return '';
    }
    return search.replace(/^\?/, '');
};
export const objectToSearchString = (obj, encodeValues = true, paramsToExclude = []) => {
    if (typeof obj !== 'object') {
        return '';
    }
    return Object.keys(obj)
        .map((key) => {
        return [obj[key]]
            .filter((value) => !!value)
            .filter(() => !paramsToExclude.includes(key))
            .map((value) => key + '=' + (encodeValues ? encodeURIComponent(value || '') : value))
            .join('&');
    })
        .filter((parameterString) => !!parameterString)
        .join('&');
};
export const appendParamsToSearchString = (currentSearch, params) => {
    const currentSearchParams = parse(currentSearch);
    const newParams = typeof params === 'string' ? parse(params) : params;
    const newSearchObject = Object.assign(Object.assign({}, currentSearchParams), newParams);
    return stringify(newSearchObject);
};
export const appendParamsToFullSearchUrl = (url, params) => {
    const currentPath = extractPathname(url);
    const currentSearch = extractSearch(url);
    const searchString = appendParamsToSearchString(currentSearch, params);
    return `${currentPath}?${searchString}`;
};
export const removeParamFromSearchString = (currentSearch, param) => {
    const queryParams = parse(currentSearch);
    if (queryParams[param]) {
        delete queryParams[param];
    }
    return stringify(queryParams);
};
export const extractParamFromSearchString = (currentSearch, param) => {
    const queryParams = parse(currentSearch);
    if (queryParams[param]) {
        return queryParams[param];
    }
    return null;
};
export const getImgResizedCDNURL = (imgURL, maxImgWidth, useBrowserPixelRatio = false) => {
    if (!imgURL.includes('atcdn'))
        return imgURL;
    const pixelRatio = (typeof window !== 'undefined' && useBrowserPixelRatio && (window === null || window === void 0 ? void 0 : window.devicePixelRatio)) || 1;
    const modifiedSrc = imgURL.split('/').slice(2);
    const indexOfMedia = modifiedSrc.indexOf('media');
    const widthOfThumbPX = Math.ceil(maxImgWidth * pixelRatio);
    modifiedSrc.splice(indexOfMedia + 1, 0, `w${widthOfThumbPX}`);
    const reassembledSrc = modifiedSrc.join('/').replace('/{resize}/', '/');
    return `https://${reassembledSrc}`;
};
export const isOriginWebview = (search) => {
    const originsInUrl = extractParamFromSearchString(search, 'origin');
    if (!originsInUrl) {
        return false;
    }
    const nativeAppsOrigins = [
        'native-apps',
        'ios-iphone-app',
        'android-phone-app',
        'ios-ipad-app',
        'android-tablet-app',
    ];
    const originList = Array.isArray(originsInUrl) ? originsInUrl : [originsInUrl];
    return originList.some((origin) => nativeAppsOrigins.includes(origin));
};
export const getIsExternalUrl = (url) => {
    try {
        if (typeof window.location.hostname === 'undefined')
            return false;
        const removeWWW = (hostname) => hostname === null || hostname === void 0 ? void 0 : hostname.replace(/^www\./, '');
        const parsedUrl = new URL(url);
        const hostname = removeWWW(parsedUrl.hostname);
        const currentHostname = removeWWW(window.location.hostname);
        const isExternal = hostname !== currentHostname;
        return isExternal;
    }
    catch (error) {
        return false;
    }
};
export const getFirstValueFromQueryParamType = (param) => {
    if (param !== null) {
        return Array.isArray(param) ? param[0] : param;
    }
    return param;
};
